import { AppRoute } from '@common/app/routes';
import { type TabBarItemsType } from '@common/types/components';

const tabBarLinks: Record<TabBarItemsType, string> = {
  Resources: AppRoute.RESOURCES,
  Materials: AppRoute.FACTORY,
  Goods: AppRoute.WORKSHOP,
  Office: AppRoute.MAIN,
  Stock: AppRoute.STOCK,
};

export { tabBarLinks };
